import React from "react";

import { IS_APP } from "@/__main__/constants.mjs";
import mainRefs from "@/__main__/refs.mjs";
import MainNav from "@/app/AppShellMainNav.jsx";
import { Outer } from "@/app/ContentHeader.style.jsx";
import FeedbackModal from "@/app/FeedbackModal.jsx";
import { useSnapshot } from "@/util/use-snapshot.mjs";

export const CONTENT_HEADER_ID = "content-header";
export const CONTENT_HEADER_MIDDLE_CLASS = "content-header-middle";

const ContentHeader = () => {
  return (
    <Outer id={CONTENT_HEADER_ID}>
      <div className={CONTENT_HEADER_MIDDLE_CLASS}>
        <MainNav />
      </div>

      {IS_APP && <FeedbackModal />}

      <FloatingElements />
    </Outer>
  );
};

const FloatingElements = () => {
  const { floatingElementsInner } = useSnapshot(mainRefs.components);

  return (
    <>
      {floatingElementsInner.map((Child, i) => (
        <Child key={Child.name + i} />
      ))}
    </>
  );
};

export default ContentHeader;
